"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var google_analytics_gtag_1 = require("./google-analytics-gtag");
var event_helpers_1 = require("./event-helpers");
exports.trackPageView = event_helpers_1.trackPageView;
exports.trackEvent = event_helpers_1.trackEvent;
exports.default = google_analytics_gtag_1.default;
